module.exports = __webpack_public_path__ + "img/icon_tt_new.020536e5.svg";